import { notification } from '../../../../utility/notification/notification.service';
import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = async (
  event,
  errors,
  values,
  targetItemData,
  isEditMode,
  setIsSubmitting,
  setTargetItemData,
  closeModal,
  onSubmit,
  orderConditions,
  newOrderCondition,
  isAddOrderConditionOpen,
  itemDataEntriesInCategory,
  storeId,
) => {
  // Filter out null, undefined, NaN and 0 values
  const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
    if (
      value !== null &&
      value !== 0 &&
      value !== undefined &&
      !Number.isNaN(value)
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});

  try {
    const promises = itemDataEntriesInCategory.map((itemData) =>
      handleSubmitBase(
        'item-data/food',
        null,
        null,
        null,
        null,
        event,
        errors,
        {
          ...filteredValues,
          orderConditions: isAddOrderConditionOpen
            ? [...(orderConditions || []), newOrderCondition]
            : orderConditions,
        },
        {
          id: itemData.id,
          ...targetItemData,
        },
        isEditMode,
        () => {},
        setTargetItemData,
        () => {},
        () => {},
        storeId,
      ),
    );
    const afterAll = () => {
      onSubmit();
      closeModal();
      setIsSubmitting(false);
      notification('success', 'editCategorySuccess');
    };
    await Promise.all(promises).then(() => afterAll());
  } catch (error) {
    console.error('Error in handleSubmit:', error);
    notification('error', 'editCategoryError');
    setIsSubmitting(false);
    throw error;
  }
};
